import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ApiService } from 'src/app/Services/api.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

@Component({
  selector: 'g10-profile-mobile-change',
  templateUrl: './profile-mobile-change.component.html',
  styleUrls: ['./profile-mobile-change.component.css']
})
export class ProfileMobileChangeComponent implements OnInit {

  @Input() popup = false;
  @Input() userData: any;
  @Output() closeEvent = new EventEmitter();
  @Output() changedMobile = new EventEmitter();

  public mobileNo:any;
  public mobileNoFocusOut:boolean = true;
  public formSubmit:boolean = false;

  constructor( public api: ApiService,
    public swal: SweetAlert,) { }

  ngOnInit(): void {
    this.initControl();
  }

  initControl(){
    this.mobileNo = new FormControl('', [Validators.required,Validators.pattern('[0-9]{10}')])
  }

  keyUpEvent(){
    this.mobileNoFocusOut= false;
  }

  keyDownEvent(){
    this.mobileNoFocusOut = true;
  }

  public checkError = (errorName: string) => {
    return this.mobileNo.hasError(errorName);
  }

  onSubmit(){
    this.formSubmit = true;
    if(this.mobileNo.valid){
      let obj = {
        contactNumber:this.mobileNo.value,
      }
      this.api.updateCurUserOrg(obj).then((res: any) => {
        console.log('response',res);
        if (res.status == 'success') {
          this.swal.swalFunction(res.status, res.status, res.message, 2000);
          setTimeout(()=>{ 
            this.closeEvent.emit(true);
            this.changedMobile.emit(true);
          }, 2500)
        }
        if (res.status == 'failure') {
          this.swal.swalFunction('error', res.status, res.message, 2000);
        }
      });
    }
  }


}
